import React, { useEffect, useState } from "react";
import { adminClient } from "../../../lib/admin";
import { toast } from "sonner";
import { KeyRound, ScrollText, Loader2 } from "lucide-react";

export default function AdminSecurity() {
  const client = adminClient();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { client.get("/admin/audit-logs").then(({ data }) => setLogs(data.logs)).catch(() => {}); }, []);

  const change = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) { toast.error("Passwords do not match"); return; }
    if (f.new_password.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    setLoading(true);
    try { await client.post("/admin/change-password", { current_password: f.current_password, new_password: f.new_password }); toast.success("Password changed"); setF({ current_password: "", new_password: "", confirm: "" }); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-security">
      <h2 className="text-xl font-black font-display mb-4">Security &amp; Audit</h2>
      <div className="grid lg:grid-cols-2 gap-6">
        <form onSubmit={change} className="bg-white border border-black/10 p-6 space-y-3 h-fit" data-testid="change-pw-form">
          <p className="text-xs font-bold uppercase tracking-wider flex items-center gap-2"><KeyRound className="w-4 h-4 text-taven-gold" /> Change Admin Password</p>
          <input required type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} placeholder="Current password" data-testid="cur-pw" className="w-full border border-black/15 px-4 py-3 text-sm outline-none focus:border-taven-gold" />
          <input required type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} placeholder="New password (min 8)" data-testid="new-pw" className="w-full border border-black/15 px-4 py-3 text-sm outline-none focus:border-taven-gold" />
          <input required type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} placeholder="Confirm new password" data-testid="confirm-pw" className="w-full border border-black/15 px-4 py-3 text-sm outline-none focus:border-taven-gold" />
          <button disabled={loading} data-testid="change-pw-submit" className="bg-taven-black text-white font-bold uppercase tracking-wider text-xs py-3 px-6 hover:bg-taven-orange disabled:opacity-60 flex items-center gap-2">{loading && <Loader2 className="w-4 h-4 animate-spin" />} Update Password</button>
        </form>

        <div className="bg-white border border-black/10 p-6">
          <p className="text-xs font-bold uppercase tracking-wider flex items-center gap-2 mb-3"><ScrollText className="w-4 h-4 text-taven-gold" /> Audit Log</p>
          <div className="max-h-[50vh] overflow-y-auto divide-y divide-black/5" data-testid="audit-log">
            {logs.length === 0 ? <p className="text-sm text-muted-foreground">No activity logged yet.</p> :
              logs.map((l) => (
                <div key={l.id} className="py-2 text-xs">
                  <span className="font-bold">{l.action}</span> · {l.target}
                  <span className="text-muted-foreground block">{l.actor_email} · {new Date(l.created_at).toLocaleString()}</span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
